export interface IRoute {
  label: string;
  path: string;
  id: number;
}

const routes: IRoute[] = [   
  {
    label: "Modificar Contraseña",
    path: "/comprobar",
    id: 1
  },
  {
    label: "Datos de Recuperación",
    path: "/tiposrecuperacion",
    id: 2
  },
  {
    label: "Recuperar Contraseña",
    path: "/recuperar",
    id: 3
  }, 
  {
    label: "Ayuda",
    path: "/help",
    id: 4
  }  
];

export default routes;